<frontend-pull-refresh></frontend-pull-refresh>

<section class="px-3">
  <div *ngIf="!isLocationOnBusinessPlan">
    <ngb-alert [dismissible]="false" class="text-center mt-3">
      The features on this page are not available on the {{ plansAlertData.notAvailableForPlan }}.
      <a routerLink="/settings/location/billing" class="alert-link" [innerText]="plansAlertData.linkText"></a>
      {{ plansAlertData.afterLinkText }}
    </ngb-alert>
  </div>

  <form *ngIf="automationsForm" [formGroup]="automationsForm" (ngSubmit)="submitting = true; submit();">
    <h1 *ngIf="location" class="pt-3">
      {{location.displayOptions.labels.customer | titlecase}} SMS-Sign Up
    </h1>
    <ng-container formGroupName="selfSignUp">
      <p>
        Enable this if you want your {{location?.displayOptions?.labels?.customer_plural}}
        to be able to add themselves to your
        waitlist via text message.<br/>
        You can post signs that say "Text <strong>ADD {{location?.selfSignUp?.publicVenueName}}
        NAME</strong> to {{smsPhoneNumber | trTel: location?.country}}
        to add yourself to our waitlist."
      </p>

      <div class="row form-group">
        <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
          <label class="col-form-label lead">Dynamic Fields</label>
          <p>Use these in your messages to fill in information in your automations on the fly.</p>
        </div>
        <div class="col-sm-7 col-md-7 col-lg-7 col-xl-5 mt-2">
        <span
          class="btn btn-info m-1 white"
          *ngFor="let field of dynamicFieldOptions"
          [ngbTooltip]="field.toolTip"
          [innerText]="field.name"
          placement="top"
        ></span>
        </div>
      </div>

      <div class="row form-group">
        <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
          <label for="self-sign-up-enabled" class="lead col-form-label">Enable sms-sign
            up</label>
        </div>
        <div class="col-sm-7 col-md-7 col-lg-7 col-xl-5 d-flex align-items-center mt-2">
          <label class="form-check-label">
            <input
              type="checkbox"
              class="form-check-input"
              name="selfSignUpEnabled"
              formControlName="enabled"
              id="self-sign-up-enabled"
            />Enabled
          </label>
        </div>
      </div>
      <div *ngIf="automationsForm.get('selfSignUp.enabled').value">
        <div class="row form-group">
          <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
            <p>
              This is the name your {{location.displayOptions?.labels?.customer_plural}}
              will type
              to add themselves to your
              waitlist. It must be at least 3 alphanumeric characters (a-z and 0-9), but
              should
              be easy for your guests to
              remember and unique to your business.
            </p>
          </div>
          <div class="col-sm-7 col-md-7 col-lg-7 col-xl-5">
            <input
              type="text"
              id="self-sign-up-public-name"
              name="publicVenueName"
              class="form-control"
              formControlName="publicVenueName"
              [class.is-invalid]="automationsForm.get('selfSignUp.publicVenueName').invalid && automationsForm.get('selfSignUp.publicVenueName').touched"
            />
            <control-messages [control]="automationsForm.get('selfSignUp.publicVenueName')"></control-messages>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
            <label for="self-sign-up-reply" class="col-form-label lead">Sign Up Reply</label>
            <p>Your default response when someone texts to sign up.</p>
          </div>
          <div
            class="col-sm-7 col-md-7 col-lg-7 col-xl-5 d-flex flex-column align-items-left">
            <div>
          <textarea
            name="signUpReply"
            id="self-sign-up-reply"
            minlength="1"
            type="text"
            rows="3"
            class="w-100 form-control"
            formControlName="reply"
            #signUpReply
            [class.is-invalid]="automationsForm.get('selfSignUp.reply').invalid && automationsForm.get('selfSignUp.reply').touched"
            trTrimSpaces
          ></textarea>
              <control-messages [control]="automationsForm.get('selfSignUp.reply')"></control-messages>
              <sms-warning [message]="automationsForm.get('selfSignUp.reply').value"></sms-warning>
              <chat-counter [maxAnsiChars]="maxAnsiChars" [maxNonAnsiChars]="maxNonAnsiChars" [chats]="signUpReply.value"></chat-counter>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <h1>Automatic Reply Actions</h1>
    <div class="row form-group mb-2" formGroupName="automations">
      <ng-container formGroupName="cancel">
        <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
          <label for="automation-cancel-enabled" class="col-form-label lead">Cancel</label>
          <p>Automatically remove {{location.displayOptions.labels.customer_plural}} from waitlist when they reply with keyword.</p>
        </div>
        <div class="col-sm-7 col-md-7 col-lg-7 col-xl-5 d-flex flex-column align-items-left">
          <div class="my-2">
            <label class="form-check-label">
              <input
                id="automation-cancel-enabled"
                type="checkbox"
                class="form-check-input"
                name="enabled"
                formControlName="enabled"
              >Enabled</label>
          </div>
          <div *ngIf="automationsForm.get('automations.cancel.enabled').value">
            <div>
              <frontend-dropdown-plain
                #cancelDropdown
                class="w-100"
                elementId="automation-cancel-keyword"
                [multiple]="true"
                formControlName="keywords"
                placeholder="Keywords"
                [addTag]="true"
                [maxSelectedItems]="5"
                [clearable]="true"
              ></frontend-dropdown-plain>
              <control-messages [control]="automationsForm.get('automations.cancel.keywords')"></control-messages>

              <label class="form-check-label mt-2 mb-1 font-weight-bold" for="automation-cancel-reply">Reply</label>
              <textarea
                id="automation-cancel-reply"
                name="reply"
                class="w-100 form-control"
                rows="3"
                formControlName="reply"
                #cancelReply
                [class.is-invalid]="automationsForm.get('automations.cancel.reply').invalid && automationsForm.get('automations.cancel.reply').touched"
                trTrimSpaces
              ></textarea>
              <control-messages [control]="automationsForm.get('automations.cancel.reply')"></control-messages>
              <sms-warning [message]="automationsForm.get('automations.cancel.reply').value"></sms-warning>
              <chat-counter [maxAnsiChars]="maxAnsiChars" [maxNonAnsiChars]="maxNonAnsiChars" [chats]="cancelReply.value"></chat-counter>
            </div>
          </div>
        </div>

        <ng-container *ngIf="location.integrations?.stripe?.enabled">
          <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
            <label class="col-form-label lead">Stripe payments no-cancellation SMS when public {{ location.displayOptions.labels.reservation_plural }} enabled</label>
            <p>Sent automatically when a customer tries to cancel a paid party within no-cancellation window and public bookings are enabled.</p>
          </div>
          <div class="col-sm-7 col-md-7 col-lg-7 col-xl-5 d-flex flex-column align-items-left">
            <label class="form-check-label mt-2 mb-1 font-weight-bold" for="automation-cancel-stripe-reply-enabled">Reply</label>
            <textarea
              id="automation-cancel-stripe-reply-enabled"
              name="stripeReplyOnPublicPageEnabled"
              class="w-100 form-control"
              rows="3"
              formControlName="stripeReplyOnPublicPageEnabled"
              #stripeReplyOnPublicPageEnabled
              [class.is-invalid]="automationsForm.get('automations.cancel.stripeReplyOnPublicPageEnabled').invalid && automationsForm.get('automations.cancel.stripeReplyOnPublicPageEnabled').touched"
              trTrimSpaces
            ></textarea>
            <control-messages [control]="automationsForm.get('automations.cancel.stripeReplyOnPublicPageEnabled')"></control-messages>
            <sms-warning [message]="automationsForm.get('automations.cancel.stripeReplyOnPublicPageEnabled').value"></sms-warning>
            <chat-counter [maxAnsiChars]="maxAnsiChars" [maxNonAnsiChars]="maxNonAnsiChars" [chats]="stripeReplyOnPublicPageEnabled.value"></chat-counter>
          </div>
        </ng-container>

        <ng-container *ngIf="location.integrations?.stripe?.enabled">
          <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
            <label class="col-form-label lead">Stripe payments no-cancellation SMS when public {{ location.displayOptions.labels.reservation_plural }} disabled</label>
            <p>Sent automatically when a customer tries to cancel a paid party within no-cancellation window and public bookings are disabled.</p>
          </div>
          <div class="col-sm-7 col-md-7 col-lg-7 col-xl-5 d-flex flex-column align-items-left">
            <label class="form-check-label mt-2 mb-1 font-weight-bold" for="automation-cancel-stripe-reply-disabled">Reply</label>
            <textarea
              id="automation-cancel-stripe-reply-disabled"
              name="stripeReplyOnPublicPageDisabled"
              class="w-100 form-control"
              rows="3"
              formControlName="stripeReplyOnPublicPageDisabled"
              #stripeReplyOnPublicPageDisabled
              [class.is-invalid]="automationsForm.get('automations.cancel.stripeReplyOnPublicPageDisabled').invalid && automationsForm.get('automations.cancel.stripeReplyOnPublicPageDisabled').touched"
              trTrimSpaces
            ></textarea>
            <control-messages [control]="automationsForm.get('automations.cancel.stripeReplyOnPublicPageDisabled')"></control-messages>
            <sms-warning [message]="automationsForm.get('automations.cancel.stripeReplyOnPublicPageDisabled').value"></sms-warning>
            <chat-counter [maxAnsiChars]="maxAnsiChars" [maxNonAnsiChars]="maxNonAnsiChars" [chats]="stripeReplyOnPublicPageDisabled.value"></chat-counter>
          </div>
        </ng-container>

        <ng-container *ngIf="location.integrations?.stripe?.enabled">
          <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
            <label class="col-form-label lead">Stripe payments cancellation SMS</label>
            <p>Sent automatically when a customer cancels a paid party outside the no-cancellation window.</p>
          </div>
          <div class="col-sm-7 col-md-7 col-lg-7 col-xl-5 d-flex flex-column align-items-left">
            <label class="form-check-label mt-2 mb-1 font-weight-bold" for="automation-cancel-stripe-reply-disabled">Reply</label>
            <textarea
              id="automation-cancel-stripe-refunded-reply"
              name="stripeReplyOnPaymentRefunded"
              class="w-100 form-control"
              rows="3"
              formControlName="stripeReplyOnPaymentRefunded"
              #stripeReplyOnPaymentRefunded
              [class.is-invalid]="automationsForm.get('automations.cancel.stripeReplyOnPaymentRefunded').invalid && automationsForm.get('automations.cancel.stripeReplyOnPublicPageDisabled').touched"
              trTrimSpaces
            ></textarea>
            <control-messages [control]="automationsForm.get('automations.cancel.stripeReplyOnPaymentRefunded')"></control-messages>
            <sms-warning [message]="automationsForm.get('automations.cancel.stripeReplyOnPaymentRefunded').value"></sms-warning>
            <chat-counter [maxAnsiChars]="maxAnsiChars" [maxNonAnsiChars]="maxNonAnsiChars" [chats]="stripeReplyOnPaymentRefunded.value"></chat-counter>
          </div>
        </ng-container>
      </ng-container>

      <ng-container formGroupName="checkin">
        <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
          <label for="automation-checkin-enabled" class="col-form-label lead">Check-In</label>
          <p>Set upcoming {{location.displayOptions.labels.customer_plural}} {{location.displayOptions.labels.reservation_plural}} status to "checked in"</p>
        </div>
        <div
          class="col-sm-7 col-md-7 col-lg-7 col-xl-5 d-flex flex-column align-items-left">
          <div class="my-2">
            <label class="form-check-label">
              <input
                id="automation-checkin-enabled"
                type="checkbox"
                class="form-check-input"
                name="enabled"
                formControlName="enabled"
              >Enabled
            </label>
          </div>
          <div *ngIf="automationsForm.get('automations.checkin.enabled').value">
            <div>
              <frontend-dropdown-plain
                #checkinDropdown
                class="w-100"
                elementId="automation-checkin-keyword"
                [multiple]="true"
                formControlName="keywords"
                placeholder="Keywords"
                [addTag]="true"
                [maxSelectedItems]="5"
                [clearable]="true"
                [disabled]="true"
              ></frontend-dropdown-plain>
              <control-messages [control]="automationsForm.get('automations.checkin.keywords')"></control-messages>

              <label class="form-check-label mt-2 mb-1 font-weight-bold" for="automation-checkin-reply">Reply</label>
              <textarea
                id="automation-checkin-reply"
                name="reply"
                class="w-100 form-control"
                rows="3"
                formControlName="reply"
                #checkinReply
                [class.is-invalid]="automationsForm.get('automations.checkin.reply').invalid && automationsForm.get('automations.checkin.reply').touched"
                trTrimSpaces
              ></textarea>
              <control-messages [control]="automationsForm.get('automations.checkin.reply')"></control-messages>
              <sms-warning [message]="automationsForm.get('automations.checkin.reply').value"></sms-warning>
              <chat-counter [maxAnsiChars]="maxAnsiChars" [maxNonAnsiChars]="maxNonAnsiChars" [chats]="checkinReply.value"></chat-counter>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container formGroupName="confirm">
        <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
          <label for="automation-confirm-enabled" class="col-form-label lead">Confirm</label>
          <p>Set upcoming {{location.displayOptions.labels.customer_plural}} {{location.displayOptions.labels.reservation_plural}} status to "confirmed"</p>
        </div>
        <div
          class="col-sm-7 col-md-7 col-lg-7 col-xl-5 d-flex flex-column align-items-left">
          <div class="my-2">
            <label class="form-check-label">
              <input
                id="automation-confirm-enabled"
                type="checkbox"
                class="form-check-input"
                name="enabled"
                formControlName="enabled"
              >Enabled
            </label>
          </div>
          <div *ngIf="automationsForm.get('automations.confirm.enabled').value">
            <div>
              <frontend-dropdown-plain
                #confirmDropdown
                class="w-100"
                elementId="automation-confirm-keyword"
                [multiple]="true"
                formControlName="keywords"
                placeholder="Keywords"
                [addTag]="true"
                [maxSelectedItems]="5"
                [clearable]="true"
              ></frontend-dropdown-plain>
              <control-messages [control]="automationsForm.get('automations.confirm.keywords')"></control-messages>

              <label class="form-check-label mt-2 mb-1 font-weight-bold" for="automation-confirm-reply">Reply</label>
              <textarea
                id="automation-confirm-reply"
                name="reply"
                class="w-100 form-control"
                rows="3"
                formControlName="reply"
                #confirmReply
                [class.is-invalid]="automationsForm.get('automations.confirm.reply').invalid && automationsForm.get('automations.confirm.reply').touched"
                trTrimSpaces
              ></textarea>
              <control-messages [control]="automationsForm.get('automations.confirm.reply')"></control-messages>
              <sms-warning [message]="automationsForm.get('automations.confirm.reply').value"></sms-warning>
              <chat-counter [maxAnsiChars]="maxAnsiChars" [maxNonAnsiChars]="maxNonAnsiChars" [chats]="confirmReply.value"></chat-counter>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container formGroupName="late">
        <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
          <label for="automation-late-enabled" class="col-form-label lead">Running Late</label>
          <p>Automatically bump the {{location.displayOptions.labels.customer}}'s quoted time by configured offset.</p>
        </div>
        <div
          class="col-sm-7 col-md-7 col-lg-7 col-xl-5 d-flex flex-column align-items-left">
          <div class="my-2">
            <label class="form-check-label">
              <input
                id="automation-late-enabled"
                type="checkbox"
                class="form-check-input"
                name="enabled"
                formControlName="enabled"
              >Enabled
            </label>
          </div>
          <div *ngIf="automationsForm.get('automations.late.enabled').value">
            <div>
              <frontend-dropdown-plain
                #lateDropdown
                class="w-100"
                elementId="automation-late-keyword"
                [multiple]="true"
                formControlName="keywords"
                placeholder="Keywords"
                [addTag]="true"
                [maxSelectedItems]="5"
                [clearable]="true"
              ></frontend-dropdown-plain>
              <control-messages [control]="automationsForm.get('automations.late.keywords')"></control-messages>

              <label class="form-check-label mt-2 mb-1 font-weight-bold" for="automation-late-offset">Offset (in minutes)</label>
              <input
                type="number"
                id="automation-late-offset"
                name="offset"
                class="w-100 form-control"
                formControlName="offset"
              />
              <control-messages [control]="automationsForm.get('automations.late.offset')"></control-messages>

              <label class="form-check-label mt-2 mb-1 font-weight-bold" for="automation-late-reply">Reply</label>
              <textarea
                id="automation-late-reply"
                name="reply"
                class="w-100 form-control"
                rows="3"
                formControlName="reply"
                #lateReply
                [class.is-invalid]="automationsForm.get('automations.late.reply').invalid && automationsForm.get('automations.late.reply').touched"
                trTrimSpaces
              ></textarea>
              <control-messages [control]="automationsForm.get('automations.late.reply')"></control-messages>
              <sms-warning [message]="automationsForm.get('automations.late.reply').value"></sms-warning>
              <chat-counter [maxAnsiChars]="maxAnsiChars" [maxNonAnsiChars]="maxNonAnsiChars" [chats]="lateReply.value"></chat-counter>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="row form-group">
      <div class="col-sm-3 offset-sm-3 offset-md-2">
        <button
          class="btn btn-success"
          style="width: 89px;"
          type="submit"
          angularticsCategory="settings"
          angulartics2On="click"
          angularticsAction="Save automations Settings"
          [disabled]="automationsForm.pristine || automationsForm.invalid"
        >Save</button>
      </div>
    </div>
  </form>

</section>
